import { Box, Chip, Divider, Paper, Stack, Typography } from "@mui/material"
import React from "react"
import useTranslationSharie from "../hooks/Language/useTranslation"
import AccountBoxIcon from "@mui/icons-material/AccountBox"
import ShopIcon from "@mui/icons-material/Shop"
import StarRateIcon from "@mui/icons-material/StarRate"
import FavoriteIcon from "@mui/icons-material/Favorite"
import SearchIcon from "@mui/icons-material/Search"
import GroupIcon from "@mui/icons-material/Group"
import PostAddIcon from "@mui/icons-material/PostAdd"
import VisibilityIcon from "@mui/icons-material/Visibility"
import PreviewIcon from "@mui/icons-material/Preview"
import Icn from "../UI/SharieIcn/SharieIcn"
import { useNavigate } from "react-router-dom"

const Activity = ({ activity, index, activitiesLength }) => {
  const t = useTranslationSharie()
  const navigate = useNavigate()

  const getTypeIcon = (type) => {
    switch (type) {
      case "view profile":
        return <AccountBoxIcon />
      case "view skill":
        return <VisibilityIcon />
      case "view group":
        return <PreviewIcon />
      case "buy skill":
        return <ShopIcon />
      case "rated skill":
        return <StarRateIcon />
      case "like":
        return <FavoriteIcon />
      case "search":
        return <SearchIcon />
      case "joined group":
        return <GroupIcon />
      case "post skill":
        return <PostAddIcon />
      case "search group":
        return <SearchIcon />
      default:
        return <PreviewIcon />
    }
  }
  return (
    <React.Fragment key={index}>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          borderRadius: "0.8rem",
          backgroundColor: activity.seen ? "#49bd45ff" : "#aa4636ff",
          mb: 2,
        }}
      >
        <Stack
          direction={"row"}
          spacing={2}
          justifyContent='space-evenly'
          alignItems='space-evenly'
          margin={"1rem"}
        >
          <Box>
            <Icn
              tooltip={t(activity.type)}
              color='inherit'
              icon={getTypeIcon(activity.type)}
              onClick={() => {
                navigate("/profile", {
                  state: {
                    user_name: activity.to,
                    editable: false,
                  },
                })
              }}
            />
          </Box>
          <Box>
            <Typography variant='body1' fontWeight={500}>
              {activity.skill_name}
            </Typography>
          </Box>
          <Box>
            <Typography variant='body2' color='text.secondary'>
              {activity.to}
            </Typography>
          </Box>

          <Box>
            <Typography variant='body1' fontWeight={500}>
              {activity.date_time}
            </Typography>
          </Box>
          <Box>
            <Chip
              label={activity.seen ? t("Seen") : t("Not Seen")}
              color={activity.seen ? "success" : "error"}
              size='small'
              sx={{ mt: 1 }}
            />
          </Box>
        </Stack>
      </Paper>

      {index < activitiesLength - 1 && <Divider />}
    </React.Fragment>
  )
}

export default React.memo(Activity)
